export default "<div class=\"container-fluid\" style=\"margin-top:30px\">\n    <div class=\"row footer-background\">\n    </div>\n</div>"